// Imports
import { faLocationDot, faUsers, faShield } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { useLocation } from 'react-router-dom';
import PageTitle from '../../shared-components/page-title';
import PageAction from '../shared-components/page-action';
import PageActions from '../shared-components/page-actions';


// Function component
const TopPortion: React.FC = () => {
	// Use React Router functionality
	const location = useLocation();
	
	
	// Return JSX
	return (
		<React.Fragment>
			<PageTitle>Account settings</PageTitle>
			
			<PageActions>
				<PageAction
					icon={faLocationDot}
					text='Addresses'
					to='addresses'
					color={location.pathname.split('/').pop() === 'addresses' ? 'primary' : 'plain'}
					inverted={location.pathname.split('/').pop() !== 'addresses'}
					data-intercom-target='page-action-addresses'
					replace
				/>
				
				<PageAction
					icon={faUsers}
					text='Members'
					to='members'
					color={location.pathname.split('/').pop() === 'members' ? 'primary' : 'plain'}
					inverted={location.pathname.split('/').pop() !== 'members'}
					data-intercom-target='page-action-members'
					replace
				/>
				
				<PageAction
					icon={faShield}
					text='Privacy'
					to='privacy'
					color={location.pathname.split('/').pop() === 'privacy' ? 'primary' : 'plain'}
					inverted={location.pathname.split('/').pop() !== 'privacy'}
					data-intercom-target='page-action-privacy'
					replace
				/>
			</PageActions>
		</React.Fragment>
	);
};

export default TopPortion;
